import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const vanta = defineConnector({
  identifier: "vanta",
  name: "Vanta",
  tagLine: "Security compliance automation",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://api\\.vanta\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Create an API application in Vanta",
      items: [
        {
          kind: "markdown",
          content: `1. Go to your [Vanta API settings](https://app.vanta.com/settings/api)
2. Create a new application
3. Click “Generate client secret”
4. Copy the client ID and client secret`,
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
    {
      title: "Define scopes for this connection",
      items: [
        {
          kind: "markdown",
          content:
            "Add [scopes](https://developer.vanta.com/docs/api-access-setup) in a space separated list below.",
        },
        {
          kind: "input",
          label: "Scopes",
          placeholder: "vanta-api.all:read vanta-api.all:write",
          required: true,
          defaultValue: "vanta-api.all:read",
          helperText: "Space separated list of desired scopes.",
          target: { kind: "oauthConnection", field: "scopes" },
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "client_credentials",
    tokenEndpoint: () => "https://api.vanta.com/oauth/token",
    clientCredentialsFrom: "db",
    tokenEndpointAuthMethod: () => "client_secret_post",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: () => "https://api.vanta.com/v1/resources/user_account",
  },
});
